import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";
const Main = lazy(() => import("../../../components/settings/score/scoreType/main"));


const ScoreSetUp = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default ScoreSetUp;




